import { mainApi } from '../index';
import type {
    ChangeTierRequest,
    CreateSubscriptionRequest,
    EstimateSubscriptionChangeResponse,
    RenewSubscriptionRequest,
    StripePromoCodeDetails,
    StripeSubscriptionResponse,
    SubscriptionPricesResponse,
} from './types';

/**
 * Fetch platform subscription prices for all countries
 */
export async function fetchSubscriptionPrices(): Promise<SubscriptionPricesResponse> {
    const response = await mainApi.get<SubscriptionPricesResponse>('v1/platform_subscriptions/prices');
    return response.data;
}

/**
 * Estimate the cost of changing subscription tier/interval
 */
export async function estimateSubscriptionChange(
    stripeId: string,
    priceId: string
): Promise<EstimateSubscriptionChangeResponse> {
    const response = await mainApi.post<EstimateSubscriptionChangeResponse>('v1/users/subscriptions/estimate', {
        stripe_id: stripeId,
        price_id: priceId,
    });
    return response.data;
}

/**
 * Change subscription tier
 */
export async function changeTier(data: ChangeTierRequest): Promise<void> {
    await mainApi.post('v1/users/subscriptions/change-tier', data);
}

/**
 * Renew a cancelled subscription
 */
export async function renewSubscription(data: RenewSubscriptionRequest): Promise<void> {
    await mainApi.post('v1/users/subscriptions/renew', data);
}

/**
 * Create a new platform subscription
 */
export async function createSubscription(data: CreateSubscriptionRequest): Promise<StripeSubscriptionResponse> {
    const response = await mainApi.post('v1/integrations/stripe/create-subscription', data);
    return response.data;
}

/**
 * Get promo code details from Stripe
 */
export async function getPromoCodeDetails(promoCode: string): Promise<StripePromoCodeDetails> {
    const response = await mainApi.get(`v1/integrations/stripe/get-promo-code-details/${promoCode}`);
    return response.data;
}
